import Axios from 'axios'

export function getAccount() {
  return Axios.get('/myAccount')
}